import { render, staticRenderFns } from "./InspectionPointResultItem.vue?vue&type=template&id=e453e1e2&scoped=true&"
import script from "./InspectionPointResultItem.vue?vue&type=script&lang=js&"
export * from "./InspectionPointResultItem.vue?vue&type=script&lang=js&"
import style0 from "./InspectionPointResultItem.vue?vue&type=style&index=0&id=e453e1e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e453e1e2",
  null
  
)

export default component.exports